import React, { useEffect } from 'react';
import { Field } from 'formik';

import { gql, useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
const gqlGetValues = gql`
  query getWasteTransactionTypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getWasteTransactionTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        description: name
        id
      }
      recordCount
    }
  }
`;
function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}
const FsWasteTranType = ({
  label = 'Επιλογή',
  name,
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore

      hook={useGetValues}
      isMulti={false}
    />
  );
};
export default FsWasteTranType;

